import React from "react";
import { Card, CardBody } from "../../../partials/controls";

const Welcome = () => {
  return (
    <div className="row">
      <div className="col-lg-12">
        <Card>
          <CardBody>
            <div className="text-center" style={{ padding: "50px 20px" }}>
              <h1 className="mb-4">Welcome!</h1>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default Welcome;
